/**
 * Memoized signal node circle for canvas rendering.
 * Prevents re-renders when other nodes or connections change.
 */
import { memo } from "react";

export interface SignalNodeCircleProps {
  id: string;
  x: number;
  y: number;
  label: string;
  iconPath?: string;
  name?: string;
  ticker?: string;
}

export const SignalNodeCircle = memo<SignalNodeCircleProps>(
  ({ x, y, label, iconPath, name, ticker }) => (
    <div
      className="absolute flex h-7 w-7 items-center justify-center rounded-full border border-cyan-500/40 bg-sa-surface/90 shadow-[0_0_10px_rgba(34,211,238,0.35)]"
      style={{
        left: `${x}%`,
        top: `${y}%`,
        transform: "translate(-50%, -50%)",
      }}
      title={label}
    >
      {iconPath ? (
        <img src={iconPath} alt={name} className="h-4 w-4 rounded-full object-cover" />
      ) : (
        <span className="text-[9px] text-cyan-400">{ticker?.slice(0, 1) ?? "S"}</span>
      )}
    </div>
  ),
);

SignalNodeCircle.displayName = "SignalNodeCircle";
